import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthEndpoint } from "../../api";

const RegisterForm = () => {
	const [formData, setFormData] = useState({
		name: "",
		address: "",
		email: "",
		phone_number: "",
	});
	const [error, setError] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const authEndpoint = new AuthEndpoint();

	const handleChange = (e) => {
		const { name, value } = e.target;

		// Only allow numbers for phone_number field
		if (name === "phone_number") {
			// Remove any non-numeric characters
			const numericValue = value.replace(/\D/g, "");
			setFormData((prev) => ({
				...prev,
				[name]: numericValue,
			}));
		} else {
			setFormData((prev) => ({
				...prev,
				[name]: value,
			}));
		}
		setError("");
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		setIsLoading(true);

		// Validate form
		if (!formData.name || !formData.email || !formData.phone_number) {
			setError("Please fill in all required fields");
			setIsLoading(false);
			return;
		}

		try {
			const requestBody = {
				name: formData.name,
				address: formData.address,
				email: formData.email,
				phone_number: formData.phone_number,
			};

			await authEndpoint.register(requestBody);

			// Success - let user handle the rest (navigation, success message, etc.)
			setError("Account created successfully");
			setFormData({
				name: "",
				address: "",
				email: "",
				phone_number: "",
			});
			// You can add navigation or success handling here
		} catch (error) {
			setError(
				error.response?.data?.message ||
					error.message ||
					"Registration failed. Please try again."
			);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="ltn__login-area pb-110">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="section-title-area text-center">
							<h1 className="section-title">
								Register <br />
								Your Account
							</h1>
							<p>
								Pastikan email dan nomor telfon aktif, untuk
								login akan membutuhkan pengiriman otp via email
								atau whatsapp
							</p>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-lg-6 offset-lg-3">
						<div className="account-login-inner">
							<form
								onSubmit={handleSubmit}
								className="ltn__form-box contact-form-box"
							>
								<input
									type="text"
									name="name"
									placeholder="User Name*"
									value={formData.name}
									onChange={handleChange}
									required
									disabled={isLoading}
								/>
								<input
									type="text"
									name="phone_number"
									placeholder="Phone Number*"
									value={formData.phone_number}
									onChange={handleChange}
									onKeyPress={(e) => {
										// Only allow numeric keys
										if (!/[0-9]/.test(e.key)) {
											e.preventDefault();
										}
									}}
									required
									disabled={isLoading}
								/>
								<input
									type="email"
									name="email"
									placeholder="Email*"
									value={formData.email}
									onChange={handleChange}
									required
									disabled={isLoading}
								/>
								<input
									type="text"
									name="address"
									placeholder="Address"
									value={formData.address}
									onChange={handleChange}
									disabled={isLoading}
								/>
								{error && (
									<div
										className="text-danger mt-2 mb-2"
										style={{ color: "red" }}
									>
										{error}
									</div>
								)}
								<div className="btn-wrapper">
									<button
										className="theme-btn-1 btn reverse-color btn-block"
										type="submit"
										disabled={isLoading}
									>
										{isLoading
											? "Creating Account..."
											: "CREATE ACCOUNT"}
									</button>
								</div>
							</form>
							<div className="by-agree text-center">
								<div className="go-to-btn mt-50 go-top">
									<Link to="/login">
										ALREADY HAVE AN ACCOUNT ?
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RegisterForm;
